import { adminApiFetch } from './apiService';

export const orderHoldService = {
  // 列表
  getRecords: async (params) => {
    const response = await adminApiFetch('order_holds/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 全選
  getIds: async (params) => {
    const response = await adminApiFetch('order_holds/get_ids', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 批次釋放
  batchRelease: async (ids, resolutionNote = '') => {
    const response = await adminApiFetch('order_holds/batch_release', {
      method: 'POST',
      body: JSON.stringify({ ids, resolution_note: resolutionNote })
    });
    return response.json();
  }
};

export default orderHoldService;
